import { UAParser } from 'ua-parser-js';
import type { URLString } from '~/interfaces/common';

/**
 * linkを新規タブで開くラッパー関数。iOSの場合、新規タブがブロックされることがあるので同タブで開く
 * @param link URLstring
 */
export const openLink = (link: URLString, params?: URLSearchParams) => {
  const parser = new UAParser();
  const isIOS = parser.getOS().name === 'iOS';

  const url = new URL(link);
  const p = new URLSearchParams(url.search);

  const q = new URLSearchParams(params);

  q.forEach((v, k) => {
    p.set(k, v);
  });

  url.search = p.toString();

  if (isIOS) {
    window.location.assign(url.href);
  } else {
    window.open(url.href, '_blank');
  }
};
